import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseEther } from "viem";
import chinaAbi from "../../utils/chinaAbi.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";
import { contractIsSpecialCodeArg } from "../../utils/specialUser";

const usePurchaseDop = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const UsdtAdress = Environment.dop;

  const purchaseDop = useCallback(
    async (amount, postApiRes, id, balance, min, stakeIndex, index, insurancePer) => {
      if (!isConnected || !account) throw new Error("WALLET_NOT_CONNECTED");

      console.log(amount, min, "amount, postApiRes,id,balance,min,stakeIndex");

      let nd;
      if (index) {
        const percent = parseFloat(amount) * insurancePer;
        const value = parseFloat(amount) + percent;
        const fixed = Math.round(parseFloat(value).toFixed(6) * 1e12) / 1e12;
        nd = parseEther(fixed.toString());
      } else {
        const fixed = Math.round(parseFloat(amount).toFixed(6) * 1e12) / 1e12;
        nd = parseEther(fixed.toString());
      }

      let minvalue = min * 0.99;
      minvalue = Math.round(parseFloat(minvalue).toFixed(6) * 1e12) / 1e12;
      minvalue = parseEther(minvalue.toString());

      try {
        const hash = await writeContractAsync({
          address: Environment.presaleContract,
          abi: chinaAbi,
          functionName: "purchaseTokenWithToken",
          args: [
            UsdtAdress,
            postApiRes?.normalizationFactor,
            postApiRes?.normalizationFactorNft,
            postApiRes?.price,
            nd,
            minvalue,
            postApiRes?.agentsAddresses,
            postApiRes?.agentsPercentages,
            postApiRes.code,
            id,
            postApiRes.deadline,
            contractIsSpecialCodeArg(postApiRes),
            postApiRes?.v,
            postApiRes?.r,
            postApiRes?.s,
          ],
        });

        console.log("PurchaseDop tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("PurchaseDop confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("PurchaseDop error:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { purchaseDop };
};

export default usePurchaseDop;
